import { createTheme } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Interpolation } from '@mui/styled-engine';
import { Theme } from '@mui/system';

export const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
    },
  },
});

export const globalStyle: Interpolation<Theme> = (theme) => ({
  html: {
    fontSize: 14,
    [theme.breakpoints.down('lg')]: {
      fontSize: 12,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
  },
});
